import { BaseCard } from '@/shared/components'
import { BaseProfileCard } from '../../../../../features/profile/ui/BaseProfileCard/BaseProfileCard'
import { getStorageItem } from '@/shared/lib/storage/localStorage'
import { USER_ROLE_KEY } from '@/features/auth'
import { Roles } from '@/entities/roles'
import { useMerchantCommissions } from '@/entities/сommissions/hooks/useMerchantCommissions '
import { formatPercent } from '@/shared/utils'

export const ProfileRates = () => {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)

  const payinOptions = getPayinOptions(userRole)
  const payoutOptions = getPayoutOptions(userRole)

  return (
    <BaseProfileCard title="Ставка">
      <div className="flex md:flex-row flex-col gap-4">
        <BaseCard className="flex-1 p-4">
          <p className="mb-4 text-text-main dark:text-white">Входящие:</p>
          <ul>
            {payinOptions &&
              payinOptions.map((el, i) => (
                <li key={i} className="flex justify-between text-text-secondary">
                  <span>{el.name}</span>
                  <span>{el.rate}</span>
                </li>
              ))}
          </ul>
        </BaseCard>
        <BaseCard className="flex-1 p-4">
          <p className="mb-4 text-text-main dark:text-white">Исходящие:</p>
          <ul>
            {payoutOptions &&
              payoutOptions.map((el, i) => (
                <li key={i} className="flex justify-between text-text-secondary">
                  <span>{el.name}</span>
                  <span>{el.rate}</span>
                </li>
              ))}
          </ul>
        </BaseCard>
      </div>
    </BaseProfileCard>
  )
}

const getPayinOptions = (role: Roles | null) => {
  if (!role) return null

  if (role === Roles.Trader) {
    return [{ name: '', rate: '' }]
  }
  if (role === Roles.Merchant) {
    const { baseCommission } = useMerchantCommissions()
    return [{ name: 'Базовая комиссия', rate: formatPercent(baseCommission) }]
  }
}

const getPayoutOptions = (role: Roles | null) => {
  if (!role) return null

  if (role === Roles.Trader) {
    return [{ name: '', rate: '' }]
  }

  if (role === Roles.Merchant) {
    return [{ name: '', rate: '' }]
  }
}
